import { createContext } from 'react';
import { NTB_JOURNEY } from 'constants/general';

const JourneyContext = createContext({
  currentJourney: NTB_JOURNEY
});

const JourneyProvider = JourneyContext.Provider;
const JourneyConsumer = JourneyContext.Consumer;

JourneyContext.displayName = 'Customer Journey';

export { JourneyContext, JourneyProvider, JourneyConsumer };
